import { render, staticRenderFns } from "./AnamnesiEdit.vue?vue&type=template&id=8a5c17c8&scoped=true"
import script from "./AnamnesiEdit.vue?vue&type=script&lang=js"
export * from "./AnamnesiEdit.vue?vue&type=script&lang=js"
import style0 from "./AnamnesiEdit.vue?vue&type=style&index=0&id=8a5c17c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5c17c8",
  null
  
)

export default component.exports